/** 24-hour HH:MM in local time, e.g. for "Data updated 14:05". */
export function formatHHMM(date: Date): string {
  return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
}
